import { TrackingList } from "../components/tracking/trackingList"
import { TrackingListKind } from "../store/trackingQuery"
import { trackingTitles } from "../components/tracking/safeFields"
import { UserbotPage } from "./userbotPage"

const TrackingPage = ({ kind }: { kind: TrackingListKind }) => (
  <UserbotPage title={trackingTitles[kind]}>
    <TrackingList key={kind} kind={kind} />
  </UserbotPage>
)
export const JoinRequestsPage = () => <TrackingPage kind="requests" />
export const JoinRecoveryPage = () => <TrackingPage kind="recovery" />
export const DialogsPage = () => <TrackingPage kind="dialogs" />
export const DialogPassesPage = () => <TrackingPage kind="passes" />
export const MembershipClarificationsPage = () => (
  <TrackingPage kind="clarifications" />
)
